import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import PageHeader from '../../components/PageHeader';
import DataTable, { Column } from '../../components/DataTable';
import { clientApi, VendorInfo } from '../../services/client';
import { toGGScore, getScoreColor, getScoreColorClass } from '../../utils/score';

const columns: Column<VendorInfo>[] = [
  { key: 'name', header: 'Vendor Name', sortable: true },
  { key: 'score', header: 'Score', sortable: true,
    render: (row) => (
      <span className={`font-semibold ${getScoreColorClass(getScoreColor(row.score))}`}>
        {toGGScore(row.score)}
      </span>
    ),
  },
  { key: 'site_count', header: 'Sites', sortable: true },
  { key: 'phone', header: 'Phone',
    render: (row) => <span className="text-slate-500">{row.phone || '—'}</span>,
  },
];

export default function ClientVendors() {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);

  const { data, isLoading } = useQuery({
    queryKey: ['client', 'vendors', page],
    queryFn: () => clientApi.getVendors({ page: String(page) }).then((r) => r.data),
  });

  const totalPages = data ? Math.ceil(data.count / 20) : 1;

  return (
    <>
      <PageHeader
        title="Vendors"
        description="Security vendors assigned to your sites"
      />
      <DataTable<VendorInfo>
        columns={columns}
        data={data?.results ?? []}
        keyExtractor={(row) => row.id}
        isLoading={isLoading}
        emptyTitle="No vendors yet"
        emptyDescription="Vendors will appear here once you assign them to a site."
        page={page}
        totalPages={totalPages}
        onPageChange={setPage}
        onRowClick={(row) => navigate(`/client/vendors/${row.id}`)}
      />
    </>
  );
}
